import { AbortController } from '@azure/abort-controller'
import { BlobServiceClient, BlobUploadCommonResponse } from '@azure/storage-blob'
import ZeroByteFileError from '@/errors/zero-byte-file-error'

export const genericDocumentUploadError =
  'There was an error uploading your documents, please try again.'

const uploadBlobs = async (
  files: File[],
  container: string,
  sas: string,
  uri: string,
  modalName: string,
) => {
  const blockSize = 256 * 1024
  const uploadPromises: Promise<BlobUploadCommonResponse>[] = []

  const blobnames = files.map((file: File, index: number) => {
    const blobname =
      `${modalName}_${index + 1}`.toLowerCase() +
      '_' +
      Math.random().toString(16).slice(2) +
      file.name.substring(file.name.lastIndexOf('.')).toLowerCase()

    if (file.size === 0) {
      throw new ZeroByteFileError(`Attempted to upload zero byte file: ${file.name}`)
    }

    const abortSignal = new AbortController().signal
    const blobServiceClient = new BlobServiceClient(`${uri}?${sas}`)
    const containerClient = blobServiceClient.getContainerClient(container)

    const blockBlobClient = containerClient.getBlockBlobClient(blobname)

    uploadPromises.push(
      blockBlobClient.uploadData(file, {
        blockSize: blockSize,
        abortSignal,
      }),
    )

    return blobname
  })

  const results = await Promise.allSettled(uploadPromises)

  const rejections = results.filter(
    ({ status }) => status === 'rejected',
  ) as PromiseRejectedResult[]

  if (rejections.length > 0) {
    throw new Error()
  }

  return blobnames
}

export const uploadFiles = async (
  files: File[],
  container: string,
  sas: string,
  uri: string,
  modalName: string,
) => {
  const data: { [key: string]: string } = {}

  await uploadBlobs(files, container, sas, uri, modalName)
    .then(blobnames => {
      if (modalName === 'proof-of-identity') {
        files.map((_, index) => {
          data[`file-${index}`] = blobnames[index]
        })
      } else {
        files.map((file: File, index) => {
          data[file.name] = blobnames[index]
        })
      }

      if (!blobnames) {
        return {}
      }
    })
    .catch(e => {
      throw e
    })

  return data
}
